import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { cmpRecentlyCreatedBoardlessRoute } from '@jira/router-routes__classic-projects-routes/src/cmpRecentlyCreatedBoardlessRoute.tsx';
import { recentlyCreatedReportPageEntrypoint } from '@jira/router-routes__next-gen-entries/src/ui/software/reports/recently-created/recentlyCreatedReportPageEntrypoint.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getTMPReportsCommonResource } from './common/ui/resources/reports/index.tsx';

export const cmpRecentlyCreatedBoardlessRouteEntry: Route = createEntry(
	cmpRecentlyCreatedBoardlessRoute,
	() => ({
		group: 'software',
		ufoName: 'software-reports.recently-created',

		entryPoint: () => recentlyCreatedReportPageEntrypoint,
		layout: softwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getNavigationResources(),
			incidentExperimentTraitResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			...getTMPReportsCommonResource(),
		],

		supportsPreviewPanel: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
